/**
 * ランタイムエラー自動報告（開発モード専用）
 * sinVのworkspace APIにエラー情報を送信し、code_fixで自動参照される
 */

const SINV_DEBUG_API = (import.meta as any).env?.VITE_SINV_DEBUG_API || 'http://localhost:8000/api/__debug/error';

function reportError(payload: Record<string, unknown>) {
  fetch(SINV_DEBUG_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, timestamp: new Date().toISOString() }),
  }).catch(() => {});
}

window.onerror = (message, source, lineno, colno, error) => {
  reportError({
    type: 'runtime',
    origin: 'frontend',
    level: 'error',
    message: String(message),
    source,
    lineno,
    colno,
    stack: error?.stack,
  });
};

window.addEventListener('unhandledrejection', (event) => {
  reportError({
    type: 'unhandledRejection',
    origin: 'frontend',
    level: 'error',
    message: String(event.reason?.message || event.reason),
    stack: event.reason?.stack,
  });
});

export {};
